import { Component } from '@angular/core';

@Component({
  selector: 'bt-auth',
  standalone: false,
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss'
})
export class AuthComponent {

}
